import React from "react";
import { connect } from 'react-redux';
import Card from "UI/Card";
import Button from "UI/Button";

import { Facebook } from "Components/Icons";
import { ExternalLinkIcon } from "@heroicons/react/outline";

import * as IntegrationsActions from "../../data/integrations/IntegrationsActions";

class FacebookPanel extends React.Component
{
    onClick = () => {
        window.location = process.env.API_URL + '/facebook/integrate?account_id=' + this.props.accountId;
    };

    render()
    {
        return <div className='grid grid-cols-3 gap-4'>
            <div className='col-span-2 space-y-4'>
                <strong>Facebook</strong>
                <p>
                    You will be redirected to Facebook where you can connect the
                    Pages you would like to use.
                </p>
                <Button type='primary' className='space-x-2' onClick={this.onClick}>
                    <span>Connect</span>
                    <ExternalLinkIcon className='w-4' />
                </Button>
            </div>
            <Card className='col-span-1'>
                <Facebook />
            </Card>
        </div>;
    }
}

const mapStateToProps = (state) => ({
    accountId: state.currentAccountId,
});

export default connect(mapStateToProps)(FacebookPanel);
